import { LifecyclePhase, useLifecycleHooksStore } from '@tundr/lifecycle-hooks';
import { useAuthStore } from '@tundr/auth';
import { appRoutesDictionary } from '../router/app-routes.dictionary';

export const sessionInitGuard = async () => {
  const auth = useAuthStore();
  if (!auth.isLogged) return { name: appRoutesDictionary.auth.login.name };

  const lifecycleHooks = useLifecycleHooksStore();
  const sessionKey = auth.selectedCompany?.id
    ? `company:${auth.selectedCompany.id}`
    : auth.user?.id
      ? `user:${auth.user.id}`
      : undefined;
  await lifecycleHooks.run(LifecyclePhase.SESSION_INIT, sessionKey);
};
